The event signaling that a `Position` failed to post or update.
